import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  .cardContainer{
    margin-top:15px;
  }
`;

export const GroupSection = styled.div`
  width: 100%;
  padding: 0 42px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &.cards {
    margin-top: -71px;
    padding: 0 16px;
  }
  @media (max-width: 586px) {        

    &.cards {
      padding: 15px 13px 15px 19px;      
      section {
        padding: 0;
      }
    }

    .container {
      width: 100%;
      min-width: 100%;
      margin-bottom: 0px;
    }

    .seletor-wrapper {
      padding: 0 10px;
      margin: 5px 0px;
      display: inline-flex;
      align-items: center;
      heigth:35px;
      .seletor-head {
        height: 32px;

        .title {
          font-size: 1.2rem;
        }

        .chevrondown{
          font-size: 1.1rem;
        }
      }
    }

    .replace-selector-title {
      .title:after {
        visibility: visible;
        left: 5px;
        position: absolute;
      }
      .title {
        visibility: hidden;
      }
    }

    .replace-selector-title.seletor-cliente {
      .title:after {
        content: 'Cliente';
      }
    }

    .replace-selector-title.seletor-pesquisa {
      .title:after {
        content: 'Pesquisa';
      }
    }

    .replace-selector-title.seletor-pergunta {
      .title:after {
        content: 'Pergunta';
      }
    }
  }
`;

export const ThemeAware = styled.div`
  input {
     background: ${(props) => props.theme.colors.headerGroupInputsBackgroundColor};
  }

  .title.selected {
    color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected} !important;
    // font-weight: 500 !important; //TODO: a pedido de edu
  }
`;
